module.exports = __webpack_public_path__ + "img/centerIndexImg2.f6d8a15b.png";